export default __webpack_public_path__ + "media/images/pages/fitness-slide-1-d657855be9cbc2d029a7a5d17b7a00dc.jpg";